<div class="row" style="margin-left: 0.5rem">
  <div class="col-12">
    <button #zoomIn type="button" class="btn btn-outline-primary mb-2">
      <fa-icon [icon]="['fas', 'plus']"></fa-icon>
    </button>
    <div class="mb-2">{{ displayZoomLevel | number: '1.0' }}%</div>
    <button #zoomOut type="button" class="btn btn-outline-primary mb-2">
      <fa-icon [icon]="['fas', 'minus']"></fa-icon>
    </button>
  </div>
</div>
